export const COOKIE_AUTH = {
  TOKEN: "traztru-token",
  TOKEN_EXPIRE_DAYS: 9000,
	USER: "traztru-user"
};
